import React from 'react';

import styled, { withTheme } from 'styled-components';
// from {Redirect} import 'react-router-dom'

import ReactDOM from 'react-dom';
// import './LoginPage.scss'
import {LoginPage} from '../../LoginPage/LoginPage'



let user = localStorage.getItem('user')

const Modal = ({ isShowing, hide, logout }) => user ? null : isShowing ? ReactDOM.createPortal(
    
    <React.Fragment>
        <Overlay className="modal-overlay" onClick={hide}>
        </Overlay>
        {/* {console.log("modal")} */}
        {/* <LoginDiv onClick={hide}> */}
        {/* {console.log("LoginDiv")} */}
          <LoginPage logout={logout}/>
        {/* </LoginDiv> */}
        
          
    </React.Fragment>, document.body
  ) : null;

// export { connectedLoginPage as LoginPage };


const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 4;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  opacity: .5;
  
`
const LoginDiv = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 5;
  
`

export default Modal;